import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import * as xlsx from "xlsx";
// mui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
// component
import ButtonMain from "../../../../../../../../../../../common/components/button/ButtonMain";

import Act from "../../../../../../../../../../../store/actions";
import { StoreContext } from "../../../../../../../../../../../store/StoreProvider";
import fireDb from "../../../../../../../../../../../api/firebase/realtime/utils";
import { uploadFile } from "../../../../../../../../main/topPanel/right/importTool/utils/importHelper";
// img
import arrowClockwiseIcon from "../../../../../../../../../../../../images/ai_image/arrow-clockwise.svg";
import saveSna from "../../../../../../../../../../../../images/ai_image/save-sna.svg";

const ButtonPanel = ({ handleExportImage }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna, user } = state;
  const { token } = user;
  const { tableData } = sna.AI;
  const [openDialog, setOpenDialog] = useState(false);
  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const handleCloseDialog = () => setOpenDialog(false);
  const handleCloseSaveDialog = () => setOpenSaveDialog(false);

  function getFileName() {
    const now = new Date(Date.now());
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const date = now.getDate();
    const hour = now.getHours();
    const minute = now.getMinutes();
    return [year, month, date, hour, minute]
      .map((item) => {
        if (item < 10) {
          return `0${item}`;
        }
        return `${item}`;
      })
      .join("");
  }
  const UploadFileApi = async ({ onSuccess, onError, file }) => {
    const files = [file];
    const onUploadSuccess = async ({ fileName, originalName }) => {
      // 儲存至 files/file-uid/
      const rtUpdatedData = {
        fileName,
        originalName,
        displayName: originalName,
        creationTime: new Date().toISOString(),
      };
      // 更新 firebase realtime
      fireDb.creatDataset({
        userId: user?.uid,
        data: rtUpdatedData,
        onSuccess: (fileUid) => {
          // 儲存至 users/user-uid/files/
          fireDb.updateUserFiles({
            userId: user?.uid,
            fileUid,
            onSuccess,
            onError,
          });
        },
        onError,
      });
    };

    const onUploadError = (err) => {
      if (onError) onError(err);
    };

    const uploadRes = await uploadFile({ files, token, user });
    if (uploadRes instanceof Error) {
      onUploadError(uploadRes);
    } else {
      const { fileName, originalName } = uploadRes;
      onUploadSuccess({ fileName, originalName });
    }
  };

  function handleImportFile() {
    const onSuccess = () => {
      setOpenSaveDialog(true);
      // 更新 dataset.personal
      dispatch({
        type: Act.SNA_REFRESH_PERSONAL_DATASET,
        payload: true,
      });
    };

    const onError = (err) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: err?.message,
        },
      });
    };

    const newtableData = tableData.map((data) => {
      const events = sna.filter.eventTypes.initial;
      const {
        srcId,
        srcLabel,
        dstId,
        dstLabel,
        mainEvn,
        subEvn,
        source,
        relationship,
      } = data;
      const eventTypeName = !data.subEvn ? data.mainEvn : data.subEvn;
      const evtTypeId = eventTypeName
        ? events.find((evn) => evn.name === eventTypeName)?.evtTypeId || ""
        : "";
      return {
        srcId,
        srcLabel,
        dstId,
        dstLabel,
        content: source,
        eventType: evtTypeId,
        eventTypeName,
        relationship,
        mainEvn,
        subEvn,
      };
    });

    const fileName = getFileName();
    const wb = xlsx.utils.book_new();
    const ws = xlsx.utils.json_to_sheet(newtableData);
    xlsx.utils.book_append_sheet(wb, ws, "sheet");
    // 呼叫 write 函式將 Excel 檔案寫入到變數中
    const arrayBuffer = xlsx.write(wb, {
      type: "array",
      bookType: "xlsx",
      FileName: `${fileName}.xlsx`,
    });

    const file = new File([arrayBuffer], `${fileName}.xlsx`, {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    UploadFileApi({ onSuccess, onError, file });
  }

  return (
    <>
      <Grid item xs>
        <ButtonMain
          fullWidth
          buttonProps={{
            text: "重新分析",
            variant: "feedback",
            onClick: () => setOpenDialog(true),
            startIcon: <img src={arrowClockwiseIcon} alt="arrow_clockwise" />,
            sx: { padding: "8px 24px" },
          }}
        />
        <Box>
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="ReAnalyzing"
            sx={{
              ".MuiPaper-root": {
                padding: 2,
              },
            }}
          >
            <Box textAlign="end">
              {" "}
              <IconButton aria-label="close" onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButton>
            </Box>

            <DialogTitle
              id="alert-dialog-title"
              sx={{
                fontWeight: "700",
                fontSize: "20px",
                lineHeight: "28.96px",
                textAlign: "center",
                padding: "0px 24px 20px 24px",
              }}
            >
              重新分析
            </DialogTitle>

            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                重新分析需清除現有資料及分析結果。請注意，清除資料後將無法復原分析結果。
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Grid container columnGap={1}>
                <Grid item xs sx={{ width: "100%" }}>
                  {" "}
                  <ButtonMain
                    buttonProps={{
                      variant: "feedback",
                      text: "取消",
                      onClick: handleCloseDialog,
                      sx: {
                        width: "100%",
                        padding: "8px 24p",
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs>
                  <ButtonMain
                    buttonProps={{
                      variant: "gradient",
                      text: "清除資料並重新分析",
                      sx: { width: "100%" },
                      onClick: () => {
                        dispatch({
                          type: Act.SNA_SET_AI_FETCH_DATA,
                          payload: "",
                        });
                        dispatch({
                          type: Act.SNA_SET_AI_INPUT_TXT,
                          payload: "",
                        });
                        dispatch({
                          type: Act.SNA_SET_AI_CURRENT_PAGE,
                          payload: "main",
                        });
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>
        </Box>
      </Grid>
      <Grid item xs container columnGap={1} sx={{ justifyContent: "end" }}>
        <Grid item>
          <ButtonMain
            fullWidth
            buttonProps={{
              variant: "linearGradient",
              text: "下載網絡圖",
              onClick: handleExportImage,
              sx: { padding: "8px 24px" },
            }}
          />
        </Grid>
        <Grid item>
          <ButtonMain
            fullWidth
            buttonProps={{
              variant: "linearGradient",
              text: "儲存至我的網絡圖",
              onClick: handleImportFile,
              sx: { padding: "8px 24px" },
            }}
          />
          <Box>
            <Dialog
              open={openSaveDialog}
              onClose={handleCloseSaveDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className="ReAnalyzing"
              sx={{
                ".MuiPaper-root": {
                  padding: 2,
                  width: 600,
                },
              }}
            >
              <Box textAlign="end">
                {" "}
                <IconButton aria-label="close" onClick={handleCloseSaveDialog}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <DialogTitle
                id="alert-dialog-title"
                sx={{
                  fontWeight: "700",
                  fontSize: "20px",
                  lineHeight: "28.96px",
                  textAlign: "center",
                  padding: "0px 24px 20px 24px",
                }}
              >
                網絡圖已儲存
              </DialogTitle>
              <DialogContent>
                <Box sx={{ textAlign: "center", borderRadius: "8px" }}>
                  <img
                    src={saveSna}
                    alt="save success"
                    style={{ maxWidth: "100%" }}
                  />{" "}
                </Box>
              </DialogContent>
            </Dialog>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ButtonPanel;

ButtonPanel.propTypes = {
  handleExportImage: PropTypes.func,
};
ButtonPanel.defaultProps = {
  handleExportImage: PropTypes.func,
};
